import { Component, Input, ViewChild } from '@angular/core';
import { AbstractValueAccessor, MakeProvider, TextFieldComponent } from '@anecdotes/design-system/form-controls';

@Component({
  selector: 'app-dropdown-search-input',
  templateUrl: './dropdown-search-input.component.html',
  providers: [MakeProvider(DropdownSearchInputComponent)]
})
export class DropdownSearchInputComponent extends AbstractValueAccessor{
  @ViewChild('textfield', { static: true })
  private textField: TextFieldComponent;

  @Input()
  placeholder: string;

  @Input()
  clearButtonEnabled = false;

  @Input()
  autoFocus: boolean;

  @Input()
  maxLength: number;

  focusSearch(): void {
    this.textField.focus();
  }
}
